import { StreamPostCardFragmentFragment } from '@/__generated__/graphql';

export const mockStreamPost: Partial<StreamPostCardFragmentFragment> = {
  __typename: 'StreamPost',
  text: 'lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum dolor sit amet consectetur adipiscing elit lorem ipsum dolor sit amet consectetur adipiscing elit',
  createdAt: new Date().toISOString(),
  deletedAt: null,
  author: {
    __typename: 'User',
    id: 'mock-user-1',
    username: 'author',
    fullName: 'Author',
    following: false,
    xComHandle: null,
    avatar: {
      __typename: 'S3Object',
      key: 'avatars/mock-user-1.jpg',
    },
  },
  media: [],
  stream: {
    __typename: 'Stream',
    id: 'mock-stream-1',
    label: 'Stream Example',
    isEmpty: false,
    paidData: [{ __typename: 'StripePrice', id: 'mock-price-1' }],
  },
};
